import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	AAA_SERVER_FILTER_EVENT,
	AAA_SERVER_FOCUS_EVENT,
	AAA_SERVER_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.aaa_servers']);

/**
 * Open the AAA Server accordion on the Templates page.
 * @return {Promise<void>} completion acknowledgement
 */
export function openAaaServerSection() {
	return openResourceSection(
		AAA_SERVER_SECTION_EVENT,
		'profile.aaa_servers',
		SECTIONS,
	);
}

/**
 * Filter the AAA Server table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyAaaServerFilter(query) {
	return dispatchAcknowledgedEvent(AAA_SERVER_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'aaa_server',
	});
}

/**
 * Point at one AAA Server row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusAaaServer(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_aaa_server_focus'));
	return dispatchAcknowledgedEvent(AAA_SERVER_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'aaa_server',
	});
}
